// extracted by mini-css-extract-plugin
module.exports = {"root":"index-root-ZcRwN"};